<div class="modal-header">
  @if (!!id) {
    <h3 class="modal-title">Buchungshistorie - Rechnungs-Nr.: {{ id }}</h3>
  }
</div>

<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="row form-group">
      <div class="col-sm-1">
        <label for="note">Kommentar:</label>
      </div>
      <div class="col-sm-6">
        <input id="note"
          class="form-control"
          name="note"
          formControlName="note"
          [ngClass]="{red_alert: !!errors['note']}">
      </div>
      <div class="col-sm-1">
        <button type="submit" class="btn btn-success">Speichern</button>
      </div>
    </div>
  </form>

  <table class="table whitetable">
    <thead>
      <tr class="minimal">
        <th class="typ">Typ</th>
        <th class="booked align-right bold">Gebucht €</th>
        <th class="skonto align-right">Skonto %</th>
        <th class="skonto-total align-right bold">Skonto €</th>
        <th class="note">Kommentar</th>
        <th class="user">Benutzer</th>
        <th class="date">Datum</th>
      </tr>
    </thead>
    <tbody>
      @for (obj of history; track obj) {
        <tr class="minimal">
          <td class="typ">
            @switch (obj.typ) {
              @case ('booking.locked') {
                Rechnung gesperrt
              }
              @case ('booking.unlocked') {
                Rechnung entsperrt
              }
              @case ('target.date.changed') {
                Fälligkeit geändert
              }
              @case ('note') {
                Notiz
              }
              @case ('storno') {
                Rechnung storniert
              }
              @case ('correction.created') {
                RG-Korrektur erstellt
              }
              @default {
                Buchung
              }
            }
          </td>
          @if (obj.expensed === null) {
            <td class="booked"></td>
          }
          @if (obj.expensed !== null) {
            <td class="booked align-right bold">{{ obj.expensed|money:2 }}&nbsp;€</td>
          }
          @if (obj.skonto === null) {
            <td class="skonto"></td>
          }
          @if (obj.skonto !== null) {
            <td class="skonto align-right">{{ obj.skonto|money:0 }}&nbsp;%</td>
          }
          @if (obj.skonto_total === null) {
            <td class="skonto-total"></td>
          }
          @if (obj.skonto_total !== null) {
            <td class="skonto-total align-right bold">{{ obj.skonto_total|money:2}}&nbsp;€</td>
          }
          <td class="note">{{ obj.note }}</td>
          <td class="user">{{ obj.username }}</td>
          <td class="date">{{ obj.date|ZonedDateTime}}</td>
        </tr>
      }
    </tbody>
  </table>

</div>

<div class="modal-footer">
</div>
